class SdfsfCompare extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.range = this.querySelector('.sdfsf-compare__range');
    if (!this.range) return;

    this.range.addEventListener('input', () => {
      this.classList.add('is-interacting');
      this.style.setProperty('--sdfsf-compare-position', `${this.range.value}%`);
    });

    if (this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      this.observer.disconnect();
      window.setTimeout(() => this.nudge(), 350);
    }, { threshold: 0.45 });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.timers) this.timers.forEach((timer) => window.clearTimeout(timer));
  }

  nudge() {
    if (this.classList.contains('is-interacting')) return;
    this.classList.add('is-hinting');
    const setPosition = (value) => {
      this.range.value = value;
      this.style.setProperty('--sdfsf-compare-position', `${value}%`);
    };
    setPosition(38);
    this.timers = [
      window.setTimeout(() => setPosition(64), 650),
      window.setTimeout(() => setPosition(50), 1300),
      window.setTimeout(() => this.classList.remove('is-hinting'), 1900)
    ];
  }
}

if (!customElements.get('sdfsf-compare')) customElements.define('sdfsf-compare', SdfsfCompare);
